module.exports = __webpack_public_path__ + "static/img/Aaron-Mooy.cf9cf15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aaron-Mooy.jpg
// module id = BxdI
// module chunks = 0